<template>
	<el-drawer title="详细信息" :visible.sync="show" :before-close="close" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="400">
		<p class="titinf">基本信息</p>
		<div class="infitem"><p class="lable">姓名</p><p class="inf">{{user.name}}</p></div>
		<div class="infitem"><p class="lable">性别</p><p class="inf">{{inf.card.gender}}</p></div>
		<div class="infitem"><p class="lable">民族</p><p class="inf">{{inf.card.nation}}</p></div>
		<div class="infitem"><p class="lable">身份证号</p><p class="inf">{{inf.card.id}}</p></div>
		<div class="infitem"><p class="lable">出生日期</p><p class="inf">{{inf.card.day}}</p></div>
		<div class="infitem"><p class="lable">农历生日</p><p class="inf">{{inf.card.cday}}</p></div>
		<div class="infitem"><p class="lable">户籍地址</p><p class="inf">{{inf.card.add}}</p></div>
		<div class="infitem"><p class="lable">现住址</p><p class="inf">{{inf.card.nowadd}}</p></div>
		<p class="titinf">最高学历</p>
		<div class="infitem"><p class="lable">证件号码</p><p class="inf">{{inf.edu.id}}</p></div>
		<div class="infitem"><p class="lable">毕业日期</p><p class="inf">{{inf.edu.day}}</p></div>
		<div class="infitem"><p class="lable">毕业院校</p><p class="inf">{{inf.edu.sch}}</p></div>
		<div class="infitem"><p class="lable">专业</p><p class="inf">{{inf.edu.major}}</p></div>
		<div class="infitem"><p class="lable">学历</p><p class="inf">{{inf.edu.edu}}</p></div>
		<p class="titinf">教师资格证</p>
		<div class="infitem"><p class="lable">证件号码</p><p class="inf">{{inf.tch.id}}</p></div>
		<div class="infitem"><p class="lable">发证日期</p><p class="inf">{{inf.tch.day}}</p></div>
		<div class="infitem"><p class="lable">种类</p><p class="inf">{{inf.tch.typ}}</p></div>
		<div class="infitem"><p class="lable">任教科目</p><p class="inf">{{inf.tch.sub}}</p></div>
		<div class="infitem" style="margin-bottom: 20px;"><p class="lable">认定机构</p><p class="inf">{{inf.tch.inst}}</p></div>
	</el-drawer>
</template>

<script>
export default{
	name:'userinf',
	data(){
		return {
			inf:{card:{},edu:{},tch:{}}
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		}
	},
	watch:{
		show(n){
			if(!n){
				this.inf={card:{},edu:{},tch:{}}
				return
			}
			//获取用户信息
			this.myfun.Loading()
			const formdata = new FormData()
			formdata.append("userid",this.user.id)
			this.axios.post("data:getOtherinf",formdata).then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.inf=e
			})
		}
	},
	methods:{
		close(){
			this.$emit("close")
		}
	}
}
</script>

<style scoped>
.titinf{
	font-size: 18px;
	font-weight: 700;
	line-height: 30px;
	padding-left: 20px;
	margin-bottom: 10px;
	margin-top: 20px;
}
.titinf:first-child{
	margin-top: 0px;
}
.infitem{
	display: flex;
	align-items: flex-start;
	margin-bottom: 10px;
}
.lable{
	width: 100px;
	text-align: right;
	padding: 5px;
	line-height: 25px;
}
.inf{
	background: #eee;
	padding: 5px;
	width: 250px;
	border-radius: 5px;
	line-height: 25px;
	min-height: 25px;
}
</style>
